import React, { PureComponent } from 'react';
import Routes from './router';
import { connect } from 'react-redux';
import { PageLoader, Error } from './components';

class App extends PureComponent {
  render() {
    if (this.props.hasErrored) {
      return <Error/>;
    }
    if (this.props.isLoading) {
      return <PageLoader/>;
    }
    return (
      (this.props.staticContent) && <Routes staticContent={this.props.staticContent}/>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    staticContent: state.staticContent,
    hasErrored: state.staticContentHasErrored,
    isLoading: state.staticContentIsLoading
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js